import Immutable from 'immutable';

const RecommendationItemRecord = Immutable.Record({
  id: undefined,
  categoryName: undefined,
  itemName: undefined,
});

export default class RecommendationItem extends RecommendationItemRecord { }



// WEBPACK FOOTER //
// ./data/SkillRecommendation/RecommendationItem/model.js